import { Button, Form, Input, Row, Col, Descriptions } from 'antd';
import type { DescriptionsProps } from 'antd';
import { atom } from 'nanostores';
import { useStore } from '@nanostores/react';
import { useEffect } from 'react';
import { User } from '../api/go';

type QueryForm = {
  user_id?: string;
  user_nick?: string;
  id_no?: string;
  user_mobile?: string;
};

interface UserInfo {
  user_id: string;
  nick_name: string;
  real_name: string;
  user_mobile: string;
  id_no: string;
  status: number;
  disable_remark: string;
}

const DefaultData = {
  loading: false,
  info: {} as UserInfo,
};

const store = atom(DefaultData);

async function loadInfo(query: QueryForm) {
  store.set({ ...store.get(), loading: true });

  const info = await User.infoEx(query);

  store.set({
    loading: false,
    info: info,
  });
}

function clearState() {
  store.set(DefaultData);
}

// 展示信用分的历史，当前值，和修改按钮

export default function UserInfo() {
  useEffect(() => {
    return () => {
      clearState();
    };
  }, []);

  const state = useStore(store);

  const borderedItems: DescriptionsProps['items'] = [
    {
      key: 'nick',
      label: '昵称',
      children: <div>{state.info.nick_name || ''}</div>,
    },
    {
      key: 'id',
      label: 'UserId',
      children: <div>{state.info.user_id || ''}</div>,
    },
    {
      key: 'real_name',
      label: '真实姓名',
      children: <div>{state.info.real_name || ''}</div>,
    },
    {
      key: 'user_mobile',
      label: '手机号',
      children: <div>{state.info.user_mobile || ''}</div>,
    },
    {
      key: 'id_no',
      label: '身份证号',
      children: <div>{state.info.id_no || ''}</div>,
    },
    {
      key: 'status',
      label: '状态',
      children: <div>{state.info.status === 0 ? '封禁' : '正常'}</div>,
    },
    {
      key: 'account_ban',
      label: '账户封禁提示',
      children: <div>{state.info.status === 0 ? state.info.disable_remark : '未封禁'}</div>,
    },
  ];

  return (
    <div>
      <Row>
        <Col span={8}>
          <Form
            name="list"
            layout="horizontal"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            style={{ maxWidth: 600 }}
            onFinish={(values: QueryForm) => {
              if (values.user_id || values.user_nick || values.user_mobile || values.id_no) {
                loadInfo(values);
              }
            }}
            autoComplete="off"
          >
            <Form.Item<QueryForm> label="User ID" name="user_id">
              <Input disabled={state.loading} />
            </Form.Item>

            <Form.Item<QueryForm> label="昵称" name="user_nick">
              <Input disabled={state.loading} />
            </Form.Item>

            <Form.Item<QueryForm> label="手机号" name="user_mobile">
              <Input disabled={state.loading} />
            </Form.Item>

            <Form.Item<QueryForm> label="身份证号" name="id_no">
              <Input disabled={state.loading} />
            </Form.Item>

            <Form.Item label={null}>
              <Button type="primary" htmlType="submit" loading={state.loading}>
                查询
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
      <div style={{ margin: '24px 0' }}>
        <Descriptions bordered items={borderedItems}></Descriptions>
      </div>
    </div>
  );
}
